var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.imageLoaded && !_vm.hasRequestFailed)?_c('div',{staticClass:"full-size-image",style:({
    backgroundImage: `url('${_vm.image}')`,
    backgroundSize: `${_vm.slide.image.backgroundSize}`})}):(_vm.hasRequestFailed)?_c('placeholder'):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }